<template>
  <div class="container-fluid">
    <div v-if="currentLng === 'en'">
    <h2 class="text-center terms-header">Privacy policy</h2><br>
    <div class="row">
      <div class="col-md-12 mobile-container">
        <div class="card">

          <div style="text-align: center;"><h4>Welcome to Universtage.com!</h4></div>

          
          <p>
            By filling in any of your data (personal or otherwise) using Universtage.com, you hereby agree to the terms of the Privacy Policy set forth below.
          </p>

          <p>Using the Site implies full and unconditional acceptance of the User with this Privacy Policy and its objectives set out in the terms and processing of his/her personal data.</p>
          <p>
            1. Types of information collected. Information required for registration and authorization: email address, name, surname or company name. Optional information: phone number, information about your profession, as well as, if you were an artist, information about your genres and styles, information about experience and education.
          </p>
          <p>
            2. Changes and deletion of Personal Data. You can change or completely delete the information in the section of the Site "Profile Editing". Email address and / or phone number can be hidden from other users. Data can be deleted partially or in whole - using the “delete profile” option in the “Editing profile” section of the Site. In this case, information about you, including photos and video material, will be completely deleted. Removal of personal information can also be requested by messaging us via a social network (list of supported social networks available on the Site). You will receive a confirmation once data has been removed.
          </p>
          <p>
            3. The use of Personal Data (name, surname and email address) is made in order to improve the services of the Site. The email address is used to recover the password. And also to send you information about new vacancies. The newsletter can be canceled upon request using the "Cancel Newsletter" link in each letter. The rest of the Personal data (name, surname) including photo and video material will be used for the purpose of advertising promoting you on social networks and on the websites of employers. The email address and phone number will not be distributed if you specify in your profile not to display them on the screen.
          </p>
          <p>
            4. Information from devices - when you logged in from a mobile,  the information about the operating system is used in order to offer you a suitable application. 
          </p>
          <p>
            5. User Consent - by providing personal information subject to this Privacy Policy the user acknowledges that as part of the processing of personal data Universtage.com is not required to provide further notice prior to the transfer of his/her personal data to third parties. The Universtage.com team is obliged to use the data of users solely for the professional benefit of the User, i.e. to support a faster and mutually beneficial conclusion of contracts between artists and their employers.
          </p>

          <p class="bold">Cookies</p>
          <p>This website does not store any information that would, on its own, allow us to identify individual users of this service without their permission. Any cookies that may be used by this website are used either solely on a per session basis or to maintain user preferences. Cookies are not shared with any third parties. </p>

        </div>
      </div>
    </div>
    </div>
    <div v-if="currentLng === 'ru'">
      <h2 class="text-center terms-header">Политика конфиденциальности</h2><br>
      <div class="row">
        <div class="col-md-12 mobile-container">
          <div class="card">
            <div style="text-align: center;"><h4>Добро пожаловать на Universtage.com!</h4></div>

            
            <p>
              Оставив любые данные, используя сайт Universtage.com, Вы тем самым выражаете согласие с условиями Политики конфиденциальности изложенной ниже.
            </p>

           
            <p>Использование Сайта означает полное и безусловное согласие Пользователя с настоящей политикой конфиденциальности и указанными в ней целями и условиями обработки его персональных данных.</p>
            <p>
              1. Типы собираемой информации. Информация обязательная для регистрации и авторизации: адрес электронной почты, имя, фамилия или назавание коллектива. Опциональная информация: номер телефона, информация о вашей профессии, а также, ели вы артист, информацию о ваших жанрах и стилях, информация об опыте и образовании. 
            </p>
            <p>
              2. Изменения и удаление Персональных данных. Изменить или полностью удалить информацию вы можете в разделе Сайта «Редактирование профиля». Адрес электронной почты и/или номер телефона можно скрыть от других пользователей. Данные можно удалить частично или целиком - с помощью опции «удалить профиль» в разделе Сайта «Редактирование профиля». При этом будет полностью удалена информация о вас включая фото и видео материал. Удаление информации о вас вы можете так же запросить сообщение на любой нашей страничке в социальных сетях указанных на Сайте. 
            </p>
            <p>
              3. Использование Персональных данных (имя, фамилия и адрес электронной почты) производится с целью улучшения сервисов Сайта. Адрес электронной почты используется для восстановлении пароля. А так же для рассылки вам информации о новых вакансиях. Рассылку можно отменить по вашему желанию с помощью ссылки «Отмена рассылки» в каждом письме. Остальные Персональные данные (имя и фамилия) включая фото и видео материал будут использоваться с целью рекламы продвигающей вас в социальных сетях и на сайтах работодателей. Адрес электронной почты и номер телефона не будут распространятся, если вы укажите в своем профиле не отображать их на экране. 
            </p>
            <p>
              4. Информация с устройств - когда вы вошли в систему с мобильного телефона, информация об операционной системе будет использована для того, чтобы предложить вам  установить приложение.
            </p>
            <p>
              5. Согласие Пользователя на обработку его персональных данных не требует от Universtage.com дополнительных уведомлений при передаче его персональных данных третьим лицам.
            </p>

            <p class="bold">Cookies</p>
            <p>Этот веб-сайт не хранит никакой информации, которая сама по себе позволила бы нам идентифицировать отдельных пользователей этой услуги без их разрешения. Любые файлы cookie, которые могут использоваться этим веб-сайтом, используются либо отдельно для каждого сеанса, либо для сохранения пользовательских настроек. Файлы cookie не передаются третьим лицам.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  export default {
    created() {

    },
    data() {
      return {
        countriesList: [],
      }
    },
    computed: {
      ...mapGetters(['currentLng']),
    },
    methods: {
      testLng() {
        console.log(this.currentLng);
      }
    }
  }
</script>

<style scoped>
.terms-header {
  color: white;
  text-shadow: 1px 1px 1px black;
}
.card {
    position: relative;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    min-width: 0;
    word-wrap: break-word;
    background-clip: border-box;
    border: 1px solid rgba(0, 0, 0, .125);
    border-radius: .25rem;
    padding: 30px 25px 30px 25px;
    margin-bottom: 50px;
}
.container h4 {
  color: #565656 !important;
}
p {
  color: #565656 !important;
  margin-bottom: 15px;
}
.bold {
  font-weight: bold;
}
p a {
  color: #565656 !important;
  font-weight: 600;
}
</style>